import { FC, useCallback } from 'react'
import styled from 'styled-components'
import { checkCategoryDepthAndShowWarning } from '../../module/utils'
import useJobCategoryStore from '../../store/store.jobCategory'
import { TJobCategory } from '../../type/jobCategoryStoreType'
import DrawCategoryGroup, { TDrawCategoryGroupInfo } from './DrawCategoryGroup'

interface IFCategoryGroupItemProps {
  category: TJobCategory
  className?: string
}

const CategoryGroupItem: FC<IFCategoryGroupItemProps> = ({
  category,
  className,
}) => {
  const { id, name, isSelect, depth, parentId, selectedChildrenIds } = category

  checkCategoryDepthAndShowWarning(depth, [1, 2])

  const activeId = useJobCategoryStore((state) => state.activeId)
  const selectId = useJobCategoryStore((state) => state.selectId)
  const unSelectId = useJobCategoryStore((state) => state.unSelectId)
  const activeIds = useJobCategoryStore((state) => state.activeIds)
  const idIsShowSelected = useJobCategoryStore(
    (state) => state.idIsShowSelected,
  )

  const isActive =
    activeIds.length > 0 && (activeIds[0] === id || activeIds[1] === id)

  const categoryGroup: TDrawCategoryGroupInfo = {
    id,
    name,
    isSelect,
    isActive,
  }

  const handleSelectCategory = useCallback(
    (categoryGroupId: string) => {
      if (depth === 1) {
        return !isActive && activeId(categoryGroupId)
      }
      if (depth === 2 && selectedChildrenIds.length === 0) {
        selectId(categoryGroupId)
      }
      if (parentId) {
        const parentIsSelect = idIsShowSelected(parentId)

        // 부모(전체)가 선택되어 있다면, 부모 선택 해제
        parentIsSelect && unSelectId(parentId)
      }
      !isActive && activeId(categoryGroupId)
    },
    [depth, isActive, selectedChildrenIds, parentId],
  )

  return (
    <StyledWrapper
      categoryGroup={categoryGroup}
      onClick={handleSelectCategory}
      className={className}
      hasChildren
    />
  )
}

export default CategoryGroupItem

const StyledWrapper = styled(DrawCategoryGroup)``
